<template>
  <BaseSidebar
    :show-back-button="true"
    :back-text="t('itinerary.sidebar.close', 'Cerrar')"
    @close="handleClose"
    @back="handleClose"
  >
    <LayoutForm
      ref="layoutForm"
      :itinerary="itinerary"
      :close-modal="handleClose"
      :add-itinerary="addItinerary"
      :handleShowCustomerModal="handleShowCustomerModal"
      @save-success="onSaveSuccess"
    />
  </BaseSidebar>
</template>

<script>
import BaseSidebar from '@/components/overlays/BaseSidebar.vue';
import LayoutForm from './LayoutForm.vue';
import { useItineraryI18n } from '@/domains/itinerary/composables';

export default {
  name: 'ItineraryFormSidebar',
  setup() {
    const { t } = useItineraryI18n();
    return { t };
  },
  components: {
    BaseSidebar,
    LayoutForm
  },
  props: {
    itinerary: {
      type: Object,
      default: null
    },
    addItinerary: {
      type: Function,
      required: true
    },
    handleShowCustomerModal: {
      type: Function,
      required: true
    },
    onNewCustomer: {
      type: Function,
      default: null
    }
  },
  emits: ['close'],
  data() {
    return {
      isDirty: false
    };
  },
  mounted() {
    this.setupCloseInterception();
    this.setupFormWatching();
    if (this.onNewCustomer) {
      this.onNewCustomer((customer) => {
        this.$refs.layoutForm?.setCustomerSelected(customer);
      });
    }
  },
  beforeUnmount() {
    this.removeCloseInterception();
  },
  methods: {
    onSaveSuccess() {
      // Reset dirty state after successful save
      this.isDirty = false;
    },
    handleClose() {
      if (this.isDirty) {
        if (this.confirmDiscard()) {
          this.$emit('close');
        }
      } else {
        this.$emit('close');
      }
    },
    setupFormWatching() {
      this.$nextTick(() => {
        const sidebar = this.$el;
        if (sidebar) {
          sidebar.addEventListener('input', () => this.isDirty = true);
          sidebar.addEventListener('change', () => this.isDirty = true);
        }
      });
    },
    setupCloseInterception() {
      this.escapeHandler = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          if (this.isDirty) {
            if (this.confirmDiscard()) {
              this.$emit('close');
            }
          } else {
            this.$emit('close');
          }
        }
      };
      document.addEventListener('keydown', this.escapeHandler, true);
      
      setTimeout(() => {
        const backdrop = document.querySelector('.overlay-backdrop');
        if (backdrop) {
          this.backdropHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.isDirty) {
              if (this.confirmDiscard()) {
                this.$emit('close');
              }
            } else {
              this.$emit('close');
            }
          };
          backdrop.addEventListener('click', this.backdropHandler, true);
        }
      }, 100);
    },
    confirmDiscard() {
      return confirm(
        this.t(
          'itinerary.sidebar.discard_confirm',
          '¿Estás seguro de que deseas cerrar? Los cambios no guardados se perderán.',
        ),
      );
    },
    removeCloseInterception() {
      if (this.escapeHandler) {
        document.removeEventListener('keydown', this.escapeHandler, true);
      }
      if (this.backdropHandler) {
        const backdrop = document.querySelector('.overlay-backdrop');
        if (backdrop) {
          backdrop.removeEventListener('click', this.backdropHandler, true);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
